import { Pipe, PipeTransform } from '@angular/core';
import { createElementID } from '../libraries/dom/dom';

@Pipe({
  name: 'elementID'
})
export class ElementIdPipe implements PipeTransform {
  transform(value: string, args?: any): any {
    return createElementID(value);
  }

}
